import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { initLenis, scrollTop, scrollToHash } from "./lib/site";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { VersionWatcher } from "./components/VersionWatcher";
import Home from "./pages/Home";
import Collections from "./pages/Collections";
import Configurator from "./pages/Configurator";
import Craftsmanship from "./pages/Craftsmanship";
import Hospitality from "./pages/Hospitality";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToHash(hash), 400);
      return () => clearTimeout(t);
    }
    scrollTop();
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="grain-overlay min-h-screen bg-obsidian text-stone-100">
      <BrowserRouter>
        <ScrollManager />
        <VersionWatcher />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/craftsmanship" element={<Craftsmanship />} />
            <Route path="/hospitality" element={<Hospitality />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
